module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAOCAYAAAD9lDaoAAAAAXNSR0IArs4c6QAAAGhJREFUKFNjZGBgYJDdNdeEiYmF9aFL/HEQHx0wggTk986zYmJkWvf7z7/wJ25JB7EqAgnK7Jpnz8rCtBKbQrBJMIBLIYoiXCZiKMKmEKsiZIX/mJksyVeE7gHSHU4wCAgGJlHRQiiCAWoXX1XepDMZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/invitation/arrow.png
// module id = q4b9
// module chunks = 2